// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"2360cf9a","171":"4481dfb3","238":"6c7aaf95","737":"612c08ae"}[chunkId] + ".chunk.js";
};